function penaltyTypeIsFirstNight(item: any) {
  const pt = item.penaltyType ?? item.deadlineType
  return pt === 'FirstNight' || pt === 'firstNight'
}

export function generatePolicyTextString(
  lang: 'en' | 'fa',
  getTranslate: (key: string) => string,
  isModification: boolean,
  policyItems: any[] = []
): string {
  if (!Array.isArray(policyItems) || policyItems.length === 0) return ''

  const mapBaseText = (policyType: string) => {
    switch (policyType) {
      case 'ReservationTime':
        return lang === 'fa'
          ? 'پس از زمان رزرو:'
          : getTranslate('after reservation time:')
      case 'CheckInTime':
        return lang === 'fa'
          ? 'قبل از زمان ورود:'
          : getTranslate('before the arrival time:')
      case 'AfterCheckInTime':
        return lang === 'fa'
          ? 'بعد از زمان ورود:'
          : getTranslate('after check-in time:')
      case 'BeforeCheckOutTime':
        return lang === 'fa'
          ? 'قبل از زمان خروج:'
          : getTranslate('before checkout time:')
      default:
        return ''
    }
  }

  return policyItems
    .map((item) => {
      if (!item) return ''
      if (item.description) return item.description

      const deadline = Number(item.deadline || 0)
      const amount = Number(item.penaltyAmount ?? item.percentage ?? 0)
      const policyType = item.policyType ?? item.deadlineType
      const baseText = mapBaseText(policyType)

      // ✅ Special case: 9999 hours means free modification policy
      if (amount === 0 && deadline >= 4320) {
        return lang === 'fa'
          ? !isModification
            ? 'قوانین کنسلی بدون جریمه است.'
            : 'قوانین تغییرات بدون جریمه است.'
          : isModification
          ? 'Free modification policy.'
          : 'Free Cancellation policy.'
      }

      const isWholeDays = deadline % 24 === 0 && deadline !== 0
      const value = isWholeDays
        ? Math.floor(deadline / 24)
        : Math.floor(deadline)
      const timeUnit =
        lang === 'fa'
          ? isWholeDays
            ? 'روز'
            : 'ساعت'
          : isWholeDays
          ? value === 1
            ? getTranslate('day')
            : getTranslate('days')
          : value === 1
          ? getTranslate('hour')
          : getTranslate('hours')

      // ✅ Free cancellation before arrival
      if (amount === 0) {
        return lang === 'fa'
          ? `${value} ${timeUnit} ${baseText} امکان کنسلی بدون جریمه وجود دارد.`
          : `${getTranslate(
              'Less than'
            )} ${value} ${timeUnit} ${baseText} ${getTranslate(
              'free cancellation'
            )}.`
      }

      // 📝 Normal penalty policy
      const ofText = penaltyTypeIsFirstNight(item)
        ? getTranslate('first night price')
        : getTranslate('total price')

      if (lang === 'fa') {
        const lessThan = getTranslate ? getTranslate('Less than') : 'کمتر از'
        return `${lessThan} ${value} ${timeUnit} ${baseText} معادل ${amount}% از ${ofText} کسر خواهد شد.`
      } else {
        return `${getTranslate(
          'Less than'
        )} ${value} ${timeUnit} ${baseText} ${amount}% ${getTranslate(
          'of the'
        )} ${ofText} ${getTranslate('will be charged.')}`
      }
    })
    .filter(Boolean)
    .join('\n')
}
